import {Input, Form, Button, message, Row, Col, Select, Switch, Spin, TreeSelect} from 'antd'
import {useEffect, useState} from "react";
import {SDrawerOrModal, STitle} from "shj-components";
import {MinusCircleOutlined, PlusCircleOutlined} from "@ant-design/icons";
import styles from '../index.module.less'
import {
  getCustomerSource, getDisPatchMethodList,
  getSalesTemplateTaskEnum,
  salesTemplateDetail,
  salesTemplateSave,
  salesTemplateUpdate
} from "@/services/customerServices.ts";
import {getEnums} from "@/services/homeService.ts";
import {useSetState} from "ahooks";
import {getRoleList} from "@/services/talkOrder.ts";
import {cloneDeep} from "lodash-es";

const AddOrEditModal = props => {
  const {open, onClose, fn, record, templateType} = props
  const [form] = Form.useForm();
  const [btnLoading, setBtnLoading] = useState(false)
  const [loading, setLoading] = useState(false)
  const [values, setValues] = useState({nodes: [{nextNodeConditionFlag: true}], templateType})
  const [state, setState] = useSetState<any>({
    bizOpTypeEnum: [],
    trackPlanDutyEnum: [],
    salesTemplateTaskList: [],
    nodeTypeEnum: [],
    roleList: [],
    templateTypeEnum: [],
    productEnum: [],
    channelTree: [],
    disPatchMethodList: [],
  })

  const title = templateType === 'CLUE' ? '商机计划' : '销售计划'

  useEffect(() => {
    if (open) {
      getOptions()
      form.setFieldsValue({templateType})
      if (record.id) getInfo()
    }
    return () => {
      setValues({nodes: [{nextNodeConditionFlag: true}], templateType})
      form.resetFields()
    }
  }, [open]);

  const getInfo = () => {
    setLoading(true)
    salesTemplateDetail(record.id).then(res => {
      form.setFieldsValue({...res, templateType})
      setValues({...res, templateType})
      setLoading(false)
    })
  }

  const formatOriginData = (data: any) => {
    if (data.children) {
      data.disabled = true;
      data.children.forEach(child => formatOriginData(child));
    }
  }

  const getOptions = async () => {
    try {
      setLoading(true);
      const bizOpTypeEnum = await getEnums('plus-crm', 'com.shj.saas.plus.crm.enums.BizOpTypeEnum')
      const trackPlanDutyEnum = await getEnums('plus-crm', 'com.shj.saas.plus.crm.enums.TrackPlanDutyEnum')
      const nodeTypeEnum = await getEnums('plus-crm', 'com.shj.saas.plus.crm.enums.NodeTypeEnum')
      const templateTypeEnum = await getEnums('plus-crm', 'com.shj.saas.plus.crm.enums.SalesTemplateTypeEnum')
      const productEnum = await getEnums('plus-crm', 'com.shj.saas.plus.crm.enums.ProductEnum')
      const salesTemplateTaskList = await getSalesTemplateTaskEnum()
      const roleList = await getRoleList()
      const channelTree = await getCustomerSource()
      const disPatchMethodList = await getDisPatchMethodList()
      channelTree.forEach(channel => formatOriginData(channel))
      console.log(channelTree)
      setState({
        bizOpTypeEnum,
        trackPlanDutyEnum,
        salesTemplateTaskList,
        nodeTypeEnum,
        roleList,
        templateTypeEnum,
        productEnum,
        channelTree,
        disPatchMethodList
      })
    } finally {
      setLoading(false);
    }
  }

  const save = () => {
    form.validateFields().then((values) => {
      setBtnLoading(true)
      const apiUrl = values.id ? salesTemplateUpdate : salesTemplateSave
      apiUrl({...values, templateType}).then(res => {
        message.success(res?.message || '操作成功');
        onClose?.()
        fn?.()
      }).finally(() => setBtnLoading(false))
    });
  }

  const onValuesChange = () => {
    console.log(form.getFieldsValue())
    setValues(form.getFieldsValue())
  }

  // const onSort = (sort: number, isUp) => {
  //   const index = isUp ? sort - 1 : sort + 1
  //   const newNodes = cloneDeep(values.nodes)
  //   newNodes[index] = values.nodes[sort]
  //   newNodes[sort] = values.nodes[index]
  //   values.nodes = newNodes
  //   setValues(values)
  //   form.setFieldsValue(values)
  // }

  return (
      <SDrawerOrModal
          mode={'drawer'}
          open={open}
          onCancel={onClose}
          width={1000}
          title={(record?.id ? "编辑" : "新增") + title}
          loading={btnLoading}
          onOk={save}
      >
        <Spin spinning={loading}>
          <Form
              style={{padding: "10px 0"}}
              form={form}
              initialValues={values}
              onValuesChange={onValuesChange}
              layout={'vertical'}
          >
            <STitle titleMode={'edit'} style={{marginBottom: 10}} title={'选择组织'}/>
            <Form.Item hidden name='id'><Input/></Form.Item>
            <Row gutter={10}>
              <Col span={8}>
                <Form.Item label={`${title}名称`}
                           name='name'
                           required={true}
                           rules={[{required: true, message: `${title}名称不能为空`}]}
                >
                  <Input placeholder={`默认${title}名称`} maxLength={20} showCount/>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label={'选择门店'}
                           name='storeIds'
                           required={true}
                           mode={'multiple'}
                           rules={[{required: true, message: '门店不能为空'}]}
                >
                  <Select mode={'multiple'}
                          maxTagCount={1}
                          placeholder={'请选择门店'}
                          options={props.companyList}
                          fieldNames={{label: 'name', value: 'id'}}
                          optionFilterProp={'name'}
                          allowClear
                          showSearch/>
                </Form.Item>
              </Col>
              {templateType !== 'CLUE' && <Col span={8}>
                <Form.Item label={'需求标签'} name='types'
                           required={true}
                           rules={[{required: true, message: '需求标签不能为空'}]}
                >
                  <Select mode={'multiple'}
                          maxTagCount={3}
                          placeholder={'请选择需求标签'}
                          options={state.bizOpTypeEnum}
                          fieldNames={{label: 'description', value: 'key'}}
                          optionFilterProp={'description'}
                          allowClear
                          showSearch/>
                </Form.Item>
              </Col>}
              {/*<Col span={8}>
                <Form.Item label={'适用阶段'} name='templateType' hidden>
                  <Select placeholder={'请选择'}
                          options={state.templateTypeEnum}
                          disabled
                          fieldNames={{label: 'description', value: 'key'}}
                          optionFilterProp={'description'}
                          allowClear
                          showSearch/>
                </Form.Item>
              </Col>*/}
              {templateType === 'CLUE' && <Col span={8}>
                <Form.Item label={'适用渠道'} name='channelIds'
                           required={true}
                           rules={[{required: true, message: '适用渠道不能为空'}]}
                >
                  <TreeSelect multiple
                              maxTagCount={1}
                              placeholder={'请选择适用渠道'}
                              treeDefaultExpandAll
                              treeData={state.channelTree}
                              treeNodeFilterProp='title'
                              allowClear
                              showSearch/>
                </Form.Item>
              </Col>}
              {templateType !== 'CLUE' && <Col span={8}>
                <Form.Item label={'产品标签'} name='product'
                           required={true}
                           rules={[{required: true, message: '产品标签不能为空'}]}
                >
                  <Select placeholder={'请选择产品标签'}
                          options={state.productEnum}
                          fieldNames={{label: 'description', value: 'key'}}
                          optionFilterProp={'description'}
                          allowClear
                          showSearch/>
                </Form.Item>
              </Col>}
            </Row>
            <STitle titleMode={'edit'} style={{marginBottom: 10}} title={'设置节点规则'}/>
            <Form.List name="nodes">
              {(fields, {add, remove}) => (
                  <div style={{display: 'flex', rowGap: 16, flexDirection: 'column'}}>
                    {fields.map((field) => (
                        <div key={field.key}>
                          <Row gutter={10}>
                            <Col span={1} style={{padding: 10, borderRadius: 5, textAlign: 'right'}}>
                              <div style={{textAlign: 'center'}}>
                                {field.name ?
                                    <MinusCircleOutlined onClick={() => remove(field.name)}
                                                         className={styles.icon}/> : null}
                              </div>
                            </Col>
                            <Col span={23} style={{background: '#F7F8FA', padding: 10, borderRadius: 5}}>
                              <Row gutter={20}>
                                <Col span={16}>
                                  <Form.Item label={`节点【${field.name + 1}】名称`}
                                             name={[field.name, 'name']}
                                             required={true}
                                             rules={[{required: true, message: `节点${field.name + 1}不能为空`}]}
                                  >
                                    <Input maxLength={20} showCount placeholder={`请输入节点名称`}/>
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Row gutter={20}>
                                <Col span={8}>
                                  <Form.Item label={'是否触发智能分配'} name={[field.name, 'dispatchFlag']}>
                                    <Switch/>
                                  </Form.Item>
                                </Col>
                                <Col span={8}>
                                  <Form.Item label={'分配角色是否取直接上级'} name={[field.name, 'directSuperiorFlag']}>
                                    <Switch/>
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Row gutter={20}>
                                <Col span={8}>
                                  <Form.Item label={'节点类型'} name={[field.name, 'nodeType']}
                                             required={true}
                                             rules={[{required: true, message: `节点类型不能为空`}]}
                                  >
                                    <Select placeholder={'请选择节点类型'}
                                            options={state.nodeTypeEnum}
                                            fieldNames={{label: 'description', value: 'key'}}
                                            optionFilterProp={'description'}
                                            allowClear
                                            showSearch/>
                                  </Form.Item>
                                </Col>
                                <Col span={8}>
                                  <Form.Item label={'分配角色'} name={[field.name, 'roleIds']}
                                             required={true}
                                             rules={[{required: true, message: `分配角色不能为空`}]}
                                  >
                                    <Select mode={'multiple'}
                                            maxTagCount={1}
                                            placeholder={'请选择分配角色'}
                                            options={state.roleList}
                                            fieldNames={{label: 'name', value: 'id'}}
                                            optionFilterProp={'name'}
                                            allowClear
                                            showSearch/>
                                  </Form.Item>
                                </Col>
                                <Col span={8}>
                                  <Form.Item label={'销售活动'} name={[field.name, 'task']}
                                             required={true}
                                             rules={[{required: true, message: `销售活动不能为空`}]}>
                                    <Select placeholder={'请选择销售活动'}
                                            mode={'multiple'}
                                            options={state.salesTemplateTaskList}
                                            maxTagCount={1}
                                            fieldNames={{label: 'taskName', value: 'taskCode'}}
                                            optionFilterProp={'taskName'}
                                            allowClear
                                            showSearch/>
                                  </Form.Item>
                                </Col>
                                <Col span={8}>
                                  <Form.Item label={'节点职责'} name={[field.name, 'dutyType']}
                                             required={true}
                                             rules={[{required: true, message: `节点职责不能为空`}]}>
                                    <Select placeholder={'请选择节点职责'}
                                            options={state.trackPlanDutyEnum}
                                            fieldNames={{label: 'description', value: 'key'}}
                                            optionFilterProp={'description'}
                                            allowClear
                                            showSearch/>
                                  </Form.Item>
                                </Col>
                                  <Col span={8}>
                                    <Form.Item label={'派单方式'} name={[field.name, 'dispatchMethodId']}>
                                      <Select placeholder={'请选择派单方式'}
                                              options={state.disPatchMethodList}
                                              fieldNames={{label: 'name', value: 'id'}}
                                              optionFilterProp={'name'}
                                              allowClear
                                              showSearch/>
                                    </Form.Item>
                                  </Col>
                                {field.name <= 0 && <>
                                  <Col span={8}>
                                    <Form.Item label={`当前${title}节点归属公司`} name={[field.name, 'companyId']}>
                                      <Select placeholder={`请选择当前${title}节点归属公司`}
                                              options={props.companyList}
                                              fieldNames={{label: 'name', value: 'id'}}
                                              optionFilterProp={'name'}
                                              allowClear
                                              showSearch/>
                                    </Form.Item>
                                  </Col>
                                </>}
                              </Row>
                              <Row>
                                <Col span={8}>
                                  <Form.Item label={'设置进入下一状态条件'}
                                             name={[field.name, 'nextNodeConditionFlag']}>
                                    <Switch/>
                                  </Form.Item>
                                </Col>
                                {
                                    values.nodes?.[field.name]?.nextNodeConditionFlag && <>
                                      <Col span={8}>
                                        <Form.Item label={'当客户满足以下条件时，才能进入当前节点'}
                                                   required={true}
                                                   rules={[{required: true, message: `条件不能为空`}]}
                                                   name={[field.name, 'nextNodeTask']}>
                                          <Select placeholder={'请选择'}
                                                  mode={'multiple'}
                                                  allowClear
                                                  showSearch
                                                  maxTagCount={1}
                                                  options={state.salesTemplateTaskList.filter(item => item.coreTaskFlag)}
                                                  fieldNames={{label: 'taskName', value: 'taskCode'}}
                                                  optionFilterProp={'taskName'}/>
                                        </Form.Item>
                                      </Col>
                                    </>
                                }
                              </Row>
                            </Col>
                          </Row>
                        </div>
                    ))}
                    <Row>
                      <Col span={23} push={1} style={{marginLeft: '-16px'}}>
                        <Button type="link" onClick={() => add({dispatchFlag: false, nextNodeConditionFlag: true})}>
                          <PlusCircleOutlined style={{fontSize: 18}}/> 添加节点
                        </Button>
                      </Col>
                    </Row>
                  </div>
              )}
            </Form.List>
          </Form>
        </Spin>
      </SDrawerOrModal>
  );
}

export default AddOrEditModal
